export const ZONE_ID = "zoneId";
export const ZONE_NAME = "zoneName";
export const COMMUNITY_ID = "communityId";
export const DESCRIPTION = "description";
export const LIST = "zones";
export const NEW = "isNew";
export const DELETED = "isDeleted";
